/* eslint-disable */
import requestDev from '@/utils/requestDev'
import { APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')

export function sentMessagesAnnually(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/sent-messages-annually',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function getTotalScrapeMP(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/total-scrapemp',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function getTotalScrapeStatus(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/total-scrapestatus',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function totalStatusPerMP(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/total_status_per_mp',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function totalKeywords(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/calculate_keywords',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function totalStatusShopee(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/total_status_shopee',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function totalStatusTokopedia(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/total_status_tokopedia',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function totalStatusLazada(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/total_status_lazada',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function totalStatusBukalapak(params) {
    return requestDev({
        url: APIReportPHP() + '/dashboard/total_status_bukalapak',
        method: 'POST',
        data: qs.stringify(params)
    })
}



// WEBPACK FOOTER //
// ./src/api/dashboard.js